import React from "react";
import { ConvexReactClient } from "convex/react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { useAuth } from "@clerk/clerk-react";

// Read Convex URLs from env with safe fallbacks provided by user
const CONVEX_URL = process.env.REACT_APP_CONVEX_URL || "https://tremendous-panda-959.convex.cloud";

// Wrapper to provide Convex client + Clerk auth to the React tree
export const ConvexClientProvider = ({ children }) => {
  const convexClient = React.useMemo(() => new ConvexReactClient(CONVEX_URL), []);

  // Use ConvexProviderWithClerk so that Clerk auth tokens are automatically
  // attached to Convex requests. This enables authenticated queries/mutations.
  return (
    <ConvexProviderWithClerk client={convexClient} useAuth={useAuth}>
      {children}
    </ConvexProviderWithClerk>
  );
};

export default ConvexClientProvider;